<template>
  <div>
    <div class="resource-category-edit-form setting-form">
      <el-row :gutter="20">
        <el-col :md="8">
          <div class="setting-cell">
            <instructor-role
              :items="instructorRoles"
              :active-role-id="activeRoleId"
              @selectRole="onChangeRole"
            />
          </div>
        </el-col>
        <el-col :md="16">
          <template>
            <div class="setting-cell">
              <div class="header">
                접근 가능 페이지
              </div>
              <instructor-access-auth-toggle 
                :toggle-model="instructorAccessAuth"
               />
            </div>
            <div class="course-controller">
              <el-button
                class="light-gray"
                @click="handleCancelAccessAuth">
                취소
              </el-button>
              <el-button
                class="black"
                :disabled="!isStorable"
                @click="handleUpdateAccessAuth">
                저장
              </el-button>
            </div>
          </template>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import InstructorRole from "./InstructorRole";
  import InstructorAccessAuthToggle from "./InstructorAccessAuthToggle"
  import WarningMessage from "@/components/element-ui/WarningMessage";
  import { computedGetters } from "@/utils/vuex-helper";
  import { fiflboxApi } from "@/utils/api"

  export default {
    name: "InstructorRoleSetting",
    components: {
      WarningMessage,
      InstructorRole,
      InstructorAccessAuthToggle
    },
    async created(){
      await this.$store.dispatch('syncInstructorRoles')
      this.activeRoleId = this.instructorRoles[0].id
    },
    data() {
      return {
        activeRoleId: null,
        activeAcceseAuthId: null,
      };
    },
    computed: {
      ...computedGetters([
        'instructorRoles',
        'instructorAccessAuth',
      ]),
      isStorable(){
        return Object.values(this.instructorAccessAuth).some(val => val === true)
      }
    },
    methods: {
      handleCancelAccessAuth() {
        this.$router.push('/setting/instructor')
      },
      async handleUpdateAccessAuth() {
        await fiflboxApi.v2.putInstructorAccessAuth(this.activeAccessAuthId, this.instructorAccessAuth);
        await this.$message("권한이 설정됐습니다.");
        this.$router.push('/setting/instructor')
      },
      async onChangeRole(role) {
        this.activeAccessAuthId = role.access_auth;
        await this.$store.dispatch('syncInstructorAccessAuthById', role.access_auth);
      },
    },
  };
</script>

<style lang="scss">
  .resource-category-edit-form {
    .setting-cell {
      border-radius: 6px;
      background-color: #ffffff;
      box-shadow: 0 2px 4px 0 rgba(180, 180, 180, 0.5);
      padding: 20px;

      .header {
        height: 27px;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        letter-spacing: -0.6px;
        color: #4a4a4a;
        border-bottom: solid 1px #d3d3d3;
        margin-bottom: 8px;
      }
    }

    .course-controller {
      margin: 10px 0;
      float: right;
    }

    .empty-message {
      min-height: 350px;

      & > div {
        text-align: center;

        .warning-message-container {
          margin-bottom: 30px;
        }
      }
    }
  }
</style>
